import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {StartEnrollmentActions} from "./StartEnrollmentActions";
import {enrollmentTokenWServiceActions} from "../../services/ws/enrollmentToken/enrollmentTokenWServiceActions";
import {EnrollmentStatusCode} from "../../services/ws/enrollmentToken/dto/EnrollmentStatusCode";

const footerType = (state = FooterType.THIN, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.THIN;
    }
};

const email = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case StartEnrollmentActions.START_ENROLLMENT_LOADED.type:
            return action.payload.email ?? '';

        case StartEnrollmentActions.CHANGE_EMAIL_ACTION.type:
            return action.payload.email;
        default:
            return state;
    }
};

const code = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case StartEnrollmentActions.START_ENROLLMENT_LOADED.type:
            return action.payload.code ?? '';

        case StartEnrollmentActions.CHANGE_CODE_ACTION.type:
            return action.payload.code;
        default:
            return state;
    }
};

const loginError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_FAILED_ACTION.type:
            return true;

        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type:
            switch(action.payload.data.status) {
                case EnrollmentStatusCode.EXPIRED:
                case EnrollmentStatusCode.REJECTED:
                case EnrollmentStatusCode.CANCELLED:
                case EnrollmentStatusCode.FINISHED:
                    return true;
                default:
                    return false;
            }

            default:
            return state;
    }
};

const tokenLoading = (state = true, action : PledgerAction) => {
    switch (action.type) {
        case StartEnrollmentActions.START_ENROLLMENT_LOADED.type: {
            const email = action.payload.email ?? '';
            const code = action.payload.code ?? '';

            if (email !== '' && code !== '') {
                return true;
            } else {
                return false;
            }
        }
        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type:
        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_FAILED_ACTION.type:
            return false;

        default:
            return state;
    }
};


const loading = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case StartEnrollmentActions.START_ENROLLMENT_LOADED.type: {
            const email = action.payload.email ?? '';
            const code = action.payload.code ?? '';

            if (email !== '' && code !== '') {
                return true;
            } else {
                return state;
            }
        }
        case StartEnrollmentActions.SET_LOADING_ACTION.type:
               return action.payload.loading;

        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type:
        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_FAILED_ACTION.type:
            return false;

        default:
            return state;
    }
};



const loginStatus = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type:
            return action.payload.data.status;
        default:
            return state;
    }
};

export interface StartEnrollmentPageComponentState extends PledgerPageComponentState {
    email: string;
    code: string;
    loginError: boolean;
    loginStatus: string;
    loading:boolean;
    tokenLoading:boolean;
}

export const startEnrollment : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        email: email(state.email, action),
        code: code(state.code, action),
        loginError: loginError(state.loginError, action),
        loginStatus: loginStatus(state.loginStatus, action),
        loading:loading(state.loading,action),
        tokenLoading:tokenLoading(state.tokenLoading,action)
    }
}
